import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Button,
  Icon,
  Spinner,
  NavigationList,
} from '@a-ui/react';

import formatCurrency from 'helpers/formatCurrency';
import Payments from 'components/Payments';
import Transactions from 'components/Transactions';
import CardBlockSwitch from 'components/CardBlockSwitch';
import useIsMobile from 'hooks/useIsMobile';

import './CardOverview.scss';

const CardOverview = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertContent, setAlertContent] = useState(null);
  const [activeTab, setActiveTab] = useState('payments');
  const { card } = useSelector(state => ({
    card: state.card,
  }));
  const [cardStatus, setCardStatus] = useState(card.isBlocked ? 'blocked' : 'unlocked');

  const history = useNavigate();
  const isMobileDevice = useIsMobile();

  useEffect(() => {
    if (!card.cardNumber) {
      history('/');
    }
  });

  const navigateToHome = () => {
    window.location.href = '/';
  }

  const chargePass = () => {
    history('/opladen');
  }

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-md-4">
          <Button
            addOn={{
              type: 'icon',
              align: 'left',
              iconProps: {
                name: 'arrow-left-1',
              },
            }}
            emphasis="low"
            onClick={navigateToHome}>Selecteer een andere sorteerpas</Button>
        </div>
      </div>
      <div className="row u-margin-top">
        <div className="col-xs-12 col-md-4">
          <div className="box-row">
            {/* LEFT SIDE CONTENT  */}
          </div>
        </div>
        <div className="col-xs-12 col-md-6">
          {!card.linked && <div className="u-margin-top"><Alert inline={true} theme="warning">
            <p>
              Deze sorteerpas is niet gekoppeld aan uw actief A-profiel. Daarom wordt de kaarthouder niet getoond en kan de pas niet geblokkeerd of gedeblokkeerd worden.
            </p>
          </Alert></div>
          }
          {cardStatus === 'blocked' && <div className="u-margin-top"><Alert inline={true} theme="warning" title={{ label: 'Sorteerpas geblokkeerd' }}>
            <p>Let op: je sorteerpas is geblokkeerd. Je kan de sorteerstraatjes niet gebruiken en je saldo niet opladen als je pas geblokkeerd is.</p>
          </Alert></div>
          }
          {showAlert &&
            <div className="u-margin-top"><Alert
              theme="warning"
              inline={true}
            >
              <p>{alertContent} <Spinner size="small" /></p>
            </Alert></div>
          }
          <div className="row u-margin-top">
            <div className="col-xs-6 col-md-8">
              <h3 style={{ fontSize: '2rem', wordBreak: 'break-word' }}>
                <strong>
                  Saldo&nbsp;
                  {isMobileDevice && <br />}
                  {formatCurrency(card.amount)}
                </strong>
                <div className="tooltip-wrapper">
                  <p><Icon name="question-circle" /></p>
                  <div className="a-tooltip">
                    Heb je heel recent nog je saldo verhoogd of afval gestort aan een sorteerstraatje? Dan kan het zijn dat je saldo nog niet is bijgewerkt.
                  </div>
                </div>
              </h3>
            </div>
            <div className="col-xs-6 col-md-4">
              <Button
                onClick={chargePass}
                disabled={cardStatus === 'blocked'}
              >Opladen</Button>
            </div>
          </div>
          <div className="box-row card-overview u-margin-top">
            <div className="row card-overview-line">
              <div className="col-xs-6 col-md-8">
                Kaartnummer
              </div>
              <div className="col-xs-6 col-md-4">
                <strong>
                  {card.cardNumber}
                </strong>
              </div>
            </div>
            <div className="row card-overview-line">
              <div className="col-xs-6 col-md-8">
                Kaarthouder
              </div>
              <div className="col-xs-6 col-md-4">
                {card.cardHolder ? card.cardHolder : <em>Onbekend</em>}
              </div>
            </div>
            <div className="row card-overview-line">
              <div className="col-xs-6 col-md-8">
                Status

                {cardStatus === 'blocked' && (
                  <p className="u-text-light">
                    Je pas kan niet gebruikt worden voor afvalstortingen. Je kan je sorteerpas ook niet opladen. Wil je dit wel? Zet je pas dan op actief.
                  </p>
                )}

                {cardStatus === 'unlocked' && (
                  <p className="u-text-light">
                    Je pas kan gebruikt worden voor afvalstortingen.
                    Je kan dit blokkeren door je pas op inactief te zetten.
                  </p>
                )}
              </div>
              <div className="col-xs-6 col-md-4"><strong>{card.linked ?
                <CardBlockSwitch
                  card={card}
                  setShowAlert={setShowAlert}
                  setAlertContent={setAlertContent}
                  cardStatus={cardStatus}
                  setCardStatus={setCardStatus}
                />
                : cardStatus === 'blocked' ? 'Geblokkeerd' : 'Actief'
              }
              </strong></div>
            </div>
          </div>
          <div className="row u-margin-top">
            <div className="col-xs-12 col-md-12">
              <a target="_blank" rel="noreferrer" href="https://www.antwerpen.be/sorteerstraten">Meer over de sorteerpas</a>
            </div>
          </div>

          {card.linked && (
            <div className="row u-margin-top-xl">
              <div className="col-xs-12 col-md-12">
                <NavigationList
                  items={[
                    {
                      active: activeTab === 'payments',
                      id: 'item-payments',
                      label: 'Betalingshistoriek'
                    },
                    {
                      active: activeTab === 'transactions',
                      id: 'item-transactions',
                      label: 'Afvalstortingen'
                    },
                  ]}
                  onItemClick={() => setActiveTab(activeTab === 'payments' ? 'transactions' : 'payments')}
                />

                {activeTab === 'payments' && <Payments cardNumber={card.cardNumber} />}
                {activeTab === 'transactions' && <Transactions cardNumber={card.cardNumber} />}
              </div>
            </div>
          )}

        </div>
      </div>
    </div >
  );
}

export default CardOverview;
